import React, { Fragment, Component } from 'react'
import {
  Container,
  Row, Col,
  CardBody, Card, CardTitle, CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { FileInput, generateFormData } from "../../../helpers/ui/FileInput";
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'


class IndexView extends Component {

  createBloc = new CreateBloc();

  constructor(props) {
    super(props)
    this.state = {
      dataForm: {}
    }
  }

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, {
      field: "attachment_detail",
      name: "guideCategoryAttachments/attachment",
    });

    await this.createBloc.fetchCreate(formData)
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault()
    this.setState({
      dataForm: values,
      confirm: true
    })
  }

  confirmResponse = (response) => {
    let forState = {}
    switch (response) {
      case 'cancel':
        forState = {
          confirm: false
        }
        break;
      case 'confirm':
        forState = {
          loading: true,
          confirm: false
        }
        this.submitData()
        break;
      case 'success':
        forState = {
          success: false,
          redirect: true
        }
        break;
      case 'failed':
        forState = {
          failed: false
        }
        break;
      default:
    }
    this.setState(forState)
  }

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break
        default:
          break
      }
    })
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Buat Tiket</CardTitle>
                  <CardSubtitle className="mb-3">
                    Buat tiket baru dengan mengisi form di bawah ini
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="fielCode"
                        className="col-md-3 col-form-label"
                      >
                        Nama Kategori <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          name="category_name"
                          placeholder="Nama Kategori"
                          type="text"
                          errorMessage="Masukan nama kategori"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="category_name"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="fielCode"
                        className="col-md-3 col-form-label"
                      >
                        Warna Background  <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          name="category_background_color"
                          placeholder="#EFFEFC"
                          type="text"
                          errorMessage="Masukan warna background"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="category_background_color"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                        <label className="col-md-3 col-form-label">Icon <span className="text-danger">*</span></label>
                        <Col md={9}>
                          <FileInput
                            name="attachment_detail"
                            validate={{ required: { value: true } }}
                            accept=".jpg,.png,.svg"
                          />
                        </Col>
                      </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <div className="form-check form-switch mb-3">
                          <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                            <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                          </AvCheckboxGroup>

                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/admin/kategori_panduan.html">
                          <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                        </Link>
                        {' '}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"

          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"

          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"

          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"

          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}

          response={this.confirmResponse}
        />
        {this.state.redirect ?
          <Redirect to='/admin/kategori_panduan.html' />
          : null}
      </Fragment>
    )
  }

}

export default IndexView